import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Select, Table } from 'antd'
import {
  MENU_VALIDATION_FIELDS,
  MENU_VALIDATION_SCOPES,
  MENU_VALIDATION_SCOPE_ALL_ITEMS,
} from '../../../constants'
import {
  formatMetricPercent,
  formatRatioAndCount,
  getValidationFieldMetrics,
} from '../../../utils'
import { renderValidationMetric } from './render-validation-metric'

const countAndRatioColumn = (title, countKey, ratioKey) => ({
  title,
  key: ratioKey,
  width: 125,
  render: (_, record) =>
    renderValidationMetric(
      formatRatioAndCount(record[ratioKey], record[countKey]),
    ),
})

const ratioColumn = (title, key, width = 130) => ({
  title,
  dataIndex: key,
  width,
  render: value => renderValidationMetric(formatMetricPercent(value)),
})

const columns = [
  {
    title: 'Field',
    dataIndex: 'field',
    fixed: 'left',
    width: 130,
  },
  countAndRatioColumn('Exact', 'exactCount', 'exactMatchRate'),
  countAndRatioColumn('Similar', 'similarCount', 'similarMatchRate'),
  countAndRatioColumn('Missing', 'missingCount', 'missingRatio'),
  countAndRatioColumn('New', 'newCount', 'newRatio'),
  ratioColumn('Average similarity', 'averageSimilarity'),
  ratioColumn('Word-count ratio', 'wordCountRatio'),
  ratioColumn('Character-count ratio', 'charCountRatio', 150),
]

const ValidationFieldMetricsTable = ({ metrics }) => {
  const [scope, setScope] = useState(MENU_VALIDATION_SCOPE_ALL_ITEMS)
  const fieldMetrics = getValidationFieldMetrics(metrics, scope)
  const dataSource = MENU_VALIDATION_FIELDS.map(field => ({
    field,
    ...(fieldMetrics[field] || {}),
  }))

  return (
    <>
      <Select
        aria-label="Validation entity scope"
        style={{ width: 180, marginBottom: 12 }}
        value={scope}
        onChange={setScope}
      >
        {MENU_VALIDATION_SCOPES.map(({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey="field"
        pagination={false}
        size="small"
        scroll={{ x: 1040 }}
      />
    </>
  )
}

ValidationFieldMetricsTable.propTypes = {
  metrics: PropTypes.object,
}

ValidationFieldMetricsTable.defaultProps = {
  metrics: {},
}

export default ValidationFieldMetricsTable
